import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import { UseFormReturn } from "react-hook-form";
import { RestaurantFormData } from "@/types/restaurantForm";

interface DescriptionFieldProps {
  form: UseFormReturn<RestaurantFormData>;
}

export const DescriptionField = ({ form }: DescriptionFieldProps) => {
  return (
    <FormField
      control={form.control}
      name="description"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Description (Optional)</FormLabel>
          <FormControl>
            <Textarea
              {...field}
              placeholder="Tell us about your restaurant and its event spaces..."
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};